
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="site-hero relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-800">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20gold%20and%20silver%20trading%20floor%20with%20modern%20screens%20displaying%20market%20data%2C%20elegant%20financial%20environment%20with%20golden%20lighting%2C%20sophisticated%20trading%20atmosphere%2C%20clean%20minimalist%20design%2C%20high-tech%20trading%20terminals&width=1920&height=1080&seq=market-hero-bg&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-1 h-1 bg-white rounded-full animate-ping"></div>
        <div className="absolute bottom-32 left-1/4 w-1.5 h-1.5 bg-yellow-300 rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-white/60 rounded-full animate-ping"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl">
          <div className="mb-8">
            <span className="inline-block px-6 py-3 bg-gradient-to-r from-yellow-400/20 to-yellow-600/20 text-yellow-400 rounded-full text-sm font-semibold border border-yellow-400/30 backdrop-blur-sm">
              <i className="ri-copper-coin-line mr-2"></i>
              {t('markets.pmt')}
            </span>
          </div>
          
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-8 leading-tight">
            {t("markets.heroMetals", { defaultValue: "Gold & Silver" })}
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
              {t("markets.heroTradingMarket", { defaultValue: "Trading Market" })}
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl leading-relaxed">
            {t('markets.ctt')}
          </p>

          <div className="flex flex-col sm:flex-row gap-6">
     <a
  href="#contract-details"
  className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-bold rounded-xl hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-lg shadow-yellow-500/25 cursor-pointer whitespace-nowrap"
>
  <i className="ri-file-text-line mr-2"></i>
  {t('markets.vts')}
</a>
            {
            /**
                        <button className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-bold rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap">
              <i className="ri-download-line mr-2"></i>
              {t('markets.dcd')}
            </button>
            */
            }

          </div>

          {/* Key Statistics */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-400 mb-2">0.01s</div>
              <div className="text-gray-400 text-sm">{t('markets.ec')}</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-400 mb-2">24/7</div>
              <div className="text-gray-400 text-sm">{t('markets.th')}</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-400 mb-2">0.3</div>
              <div className="text-gray-400 text-sm">{t('markets.ms')}</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-400 mb-2">1:100</div>
              <div className="text-gray-400 text-sm">{t('markets.ml')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
